import { c } from 'react-compiler-runtime';
import { useFormControlContext } from './_FormControlContext.js';
import { InputLabel } from '../internal/components/InputLabel.js';
import { jsx } from 'react/jsx-runtime';

const FormControlLabel = t0 => {
  const $ = c(25);
  let as;
  let children;
  let className;
  let htmlFor;
  let id;
  let props;
  let requiredText;
  let t1;
  let visuallyHidden;
  if ($[0] !== t0) {
    ({
      as,
      children,
      htmlFor,
      id,
      visuallyHidden,
      requiredIndicator: t1,
      requiredText,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = children;
    $[3] = className;
    $[4] = htmlFor;
    $[5] = id;
    $[6] = props;
    $[7] = requiredText;
    $[8] = t1;
    $[9] = visuallyHidden;
  } else {
    as = $[1];
    children = $[2];
    className = $[3];
    htmlFor = $[4];
    id = $[5];
    props = $[6];
    requiredText = $[7];
    t1 = $[8];
    visuallyHidden = $[9];
  }
  const requiredIndicator = t1 === undefined ? true : t1;
  const {
    disabled,
    id: formControlId,
    required
  } = useFormControlContext();
  let t2;
  if ($[10] !== as || $[11] !== className || $[12] !== disabled || $[13] !== formControlId || $[14] !== htmlFor || $[15] !== id || $[16] !== props || $[17] !== required || $[18] !== requiredIndicator || $[19] !== requiredText || $[20] !== visuallyHidden) {
    t2 = as === "legend" || as === "span" ? {
      as,
      id,
      className,
      visuallyHidden,
      required,
      requiredText,
      requiredIndicator,
      disabled,
      ...props
    } : {
      as,
      id,
      className,
      visuallyHidden,
      htmlFor: htmlFor || formControlId,
      required,
      requiredText,
      requiredIndicator,
      disabled,
      ...props
    };
    $[10] = as;
    $[11] = className;
    $[12] = disabled;
    $[13] = formControlId;
    $[14] = htmlFor;
    $[15] = id;
    $[16] = props;
    $[17] = required;
    $[18] = requiredIndicator;
    $[19] = requiredText;
    $[20] = visuallyHidden;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  const labelProps = t2;
  let t3;
  if ($[22] !== children || $[23] !== labelProps) {
    t3 = /*#__PURE__*/jsx(InputLabel, {
      ...labelProps,
      children: children
    });
    $[22] = children;
    $[23] = labelProps;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  return t3;
};
FormControlLabel.__SLOT__ = Symbol('FormControl.Label');

export { FormControlLabel as default };
